(function () {
  'use strict';

  var SELECTOR = '[data-tp-faq]';
  var ITEM_SELECTOR = '[data-tp-faq-item]';
  var SUMMARY_SELECTOR = '[data-tp-faq-summary]';
  var ANSWER_SELECTOR = '[data-tp-faq-answer]';
  var DURATION = 320;
  var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function prefersReducedMotion() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function TPFAQ(root) {
    this.root = root;
    this.allowMultiple = root.getAttribute('data-allow-multiple') === 'true';
    this.items = Array.prototype.slice.call(root.querySelectorAll(ITEM_SELECTOR));
    this.animations = new WeakMap();
    this.handlers = [];

    this.init();
  }

  TPFAQ.prototype.init = function () {
    var self = this;

    this.items.forEach(function (item) {
      var summary = item.querySelector(SUMMARY_SELECTOR);
      var answer = item.querySelector(ANSWER_SELECTOR);

      if (!summary || !answer) return;

      /* The first FAQ may render open from Liquid. Keep that initial state instant. */
      answer.style.height = item.open ? 'auto' : '0px';
      answer.style.opacity = item.open ? '1' : '0';

      var handler = function (event) {
        event.preventDefault();
        self.toggle(item);
      };

      summary.addEventListener('click', handler);
      self.handlers.push({ summary: summary, handler: handler });
    });
  };

  TPFAQ.prototype.cancelAnimation = function (item) {
    var current = this.animations.get(item);
    if (current) {
      try {
        current.cancel();
      } catch (error) {}
      this.animations.delete(item);
    }
  };

  TPFAQ.prototype.toggle = function (item) {
    if (item.open) {
      this.close(item);
      return;
    }

    if (!this.allowMultiple) {
      var self = this;
      this.items.forEach(function (other) {
        if (other !== item && other.open) {
          self.close(other);
        }
      });
    }

    this.open(item);
  };

  TPFAQ.prototype.open = function (item) {
    var answer = item.querySelector(ANSWER_SELECTOR);
    if (!answer) return;

    this.cancelAnimation(item);
    item.open = true;

    if (prefersReducedMotion() || !answer.animate) {
      answer.style.height = 'auto';
      answer.style.opacity = '1';
      return;
    }

    answer.style.height = 'auto';
    var targetHeight = answer.scrollHeight;
    answer.style.height = '0px';
    answer.style.opacity = '0';

    var animation = answer.animate(
      [
        { height: '0px', opacity: 0 },
        { height: targetHeight + 'px', opacity: 1 }
      ],
      {
        duration: DURATION,
        easing: EASING
      }
    );

    this.animations.set(item, animation);

    var self = this;
    animation.onfinish = function () {
      answer.style.height = 'auto';
      answer.style.opacity = '1';
      self.animations.delete(item);
    };

    animation.oncancel = function () {
      self.animations.delete(item);
    };
  };

  TPFAQ.prototype.close = function (item) {
    var answer = item.querySelector(ANSWER_SELECTOR);
    if (!answer) return;

    this.cancelAnimation(item);

    if (prefersReducedMotion() || !answer.animate) {
      item.open = false;
      answer.style.height = '0px';
      answer.style.opacity = '0';
      return;
    }

    var startHeight = answer.getBoundingClientRect().height || answer.scrollHeight;
    answer.style.height = startHeight + 'px';
    answer.style.opacity = '1';

    var animation = answer.animate(
      [
        { height: startHeight + 'px', opacity: 1 },
        { height: '0px', opacity: 0 }
      ],
      {
        duration: DURATION,
        easing: EASING
      }
    );

    this.animations.set(item, animation);

    var self = this;
    animation.onfinish = function () {
      item.open = false;
      answer.style.height = '0px';
      answer.style.opacity = '0';
      self.animations.delete(item);
    };

    animation.oncancel = function () {
      self.animations.delete(item);
    };
  };

  TPFAQ.prototype.destroy = function () {
    this.handlers.forEach(function (entry) {
      entry.summary.removeEventListener('click', entry.handler);
    });

    this.items.forEach(function (item) {
      var answer = item.querySelector(ANSWER_SELECTOR);
      if (answer) {
        answer.style.height = '';
        answer.style.opacity = '';
      }
    });

    this.handlers = [];
  };

  function initWithin(context) {
    var roots = context.matches && context.matches(SELECTOR)
      ? [context]
      : Array.prototype.slice.call(context.querySelectorAll(SELECTOR));

    roots.forEach(function (root) {
      if (root.tpFaqInstance) return;
      root.tpFaqInstance = new TPFAQ(root);
    });
  }

  function destroyWithin(context) {
    var roots = context.matches && context.matches(SELECTOR)
      ? [context]
      : Array.prototype.slice.call(context.querySelectorAll(SELECTOR));

    roots.forEach(function (root) {
      if (!root.tpFaqInstance) return;
      root.tpFaqInstance.destroy();
      root.tpFaqInstance = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWithin(document);
    });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyWithin(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest ? event.target.closest(ITEM_SELECTOR) : null;
    var root = event.target.closest ? event.target.closest(SELECTOR) : null;

    if (!item || !root || !root.tpFaqInstance || item.open) return;

    if (!root.tpFaqInstance.allowMultiple) {
      root.tpFaqInstance.items.forEach(function (other) {
        if (other !== item && other.open) {
          root.tpFaqInstance.close(other);
        }
      });
    }

    root.tpFaqInstance.open(item);
  });
})();
